import ___default from "lodash";
const isValidSegmentSelectionForm = (values) => {
  let errors = {};
  if (values.customSegments.length > 0) {
    errors.customSegments = ___default.map(values.customSegments, (segment) => {
      var _a;
      const customSegmentError = {};
      if (!segment.name) {
        customSegmentError.name = "Required";
      } else if (!segment.name.match(/^[a-zA-Z_][a-zA-Z0-9_]*$/g)) {
        customSegmentError.name = "Name must start with a letter or underscore. Alphanumeric characters and underscores are allowed in the remainder of the condition.";
      }
      if (!((_a = segment.expression) == null ? void 0 : _a.trim())) {
        customSegmentError.expression = "Required";
      }
      return customSegmentError;
    });
    if (!___default.some(errors.customSegments, (s) => !!s.name || !!s.expression)) {
      delete errors.customSegments;
    }
  }
  return errors;
};
export {
  isValidSegmentSelectionForm
};
//# sourceMappingURL=SegmentSelectionForm.validation.js.map
